import { render, staticRenderFns } from "./overviewFeratelHuis2.vue?vue&type=template&id=0612b2bd"
import script from "./overviewFeratelHuis2.vue?vue&type=script&lang=js"
export * from "./overviewFeratelHuis2.vue?vue&type=script&lang=js"
import style0 from "./overviewFeratelHuis2.vue?vue&type=style&index=0&id=0612b2bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports